import { useEffect, useState } from "react";

const useScrollState = () => {
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const newIsScrolledToTop = (window.scrollY ?? 0) <= 0;
      setIsScrolledToTop(newIsScrolledToTop);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { isScrolledToTop };
};

export default useScrollState;
